import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import React, { useState } from 'react';
import type { NumberFormatProps } from 'react-number-format';
import NumberFormat from 'react-number-format';
import type { BaseInputProps } from '../Input';
import { Input } from '../Input';

const FormattedInput = styled(Input)`
  width: 100%;
`;

const InputContainer = styled.div`
  position: relative;
`;

export interface INumberFormatInputProps
  extends NumberFormatProps,
    BaseInputProps {
  id?: string;
  hideSuffix?: boolean;
  suffix?: string;
  input?: React.ComponentType<any>;
}

export function NumberFormatInput({
  inputSize,
  hideSuffix,
  input,
  suffix,
  ...rest
}: INumberFormatInputProps) {
  const { locale } = useResource();
  const [focused, setFocused] = useState(false);
  const formatSuffix =
    input || (inputSize === 'small' && !hideSuffix) ? suffix : undefined;

  return (
    <InputContainer>
      <NumberFormat
        customInput={input ?? FormattedInput}
        thousandSeparator={locale === 'is' ? '.' : ','}
        decimalSeparator={locale === 'is' ? ',' : '.'}
        displayType="input"
        inputSize={inputSize}
        allowEmptyFormatting
        suffix={
          rest.labelVariant !== 'aboveInput' && !rest.value && !focused
            ? undefined
            : suffix
        }
        /* Need to send in suffix under new name so custom input can work with it */
        hackSuffix={!hideSuffix ? formatSuffix : undefined}
        onFocus={(e) => {
          setFocused(true);
          if (rest.onFocus) {
            rest.onFocus(e);
          }
        }}
        onBlur={(e) => {
          setFocused(false);
          if (rest.onBlur) {
            rest.onBlur(e);
          }
        }}
        {...rest}
      />
    </InputContainer>
  );
}
